module.exports = __webpack_public_path__ + "static/media/2005-poom.e27012b0.jpg";